{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Share Transaction",
  "description": "Variables needed for share transactions like issuances, repurchases and transfers.",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "share_class": { "$ref": "#/definitions/share_class" },
    "share_issuance": {
      "$ref": "#/definitions/share_issuance"
    },
    "share_transfer": {
      "$ref": "#/definitions/share_transfer"
    },
    "share_repurchase": {
      "$ref": "#/definitions/share_repurchase"
    },
    "option_exercise": {
      "$ref": "#/definitions/option_exercise"
    },
    "warrant_exercise": {
      "$ref": "#/definitions/warrant_exercise"
    },
    "stakeholder": { "$ref": "#/definitions/stakeholder" },
    "company": { "$ref": "#/definitions/company" }
  },
  "additionalProperties": false
}
